module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "3.58em",
      "color": "#FFFFFF"
    }
  }, [_vm._v("of Cape Cod")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "2.67em",
      "color": "#FFFFFF"
    }
  }, [_vm._v("and the Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-3__And__Centre_Alignment"
  }, [_c('span', [_vm._v("Also by Barbara Sillery")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-6"
  }, [_vm._v("The Haunting of Louisiana")]), _c('br'), _c('span', {
    staticClass: "C_span_char-style-override-6"
  }, [_vm._v("The Haunting of Mississippi")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0